export default ({ breadcrumbs = [], hideContext = false } = {}) => {
    const itemListElement = breadcrumbs.map((item, index) => {
        const { text, to } = item;

        return {
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': to,
                name: text
            }
        };
    });

    return {
        ...(!hideContext && { '@context': 'https://schema.org' }),
        '@type': 'BreadcrumbList',
        itemListElement
    };
};
